<svelte:options runes={true} />

<script lang="ts">
  import type { Filter } from "~/lib/filters/types";
  import FilterCheckboxList from "~/components/filters/FilterCheckboxList/FilterCheckboxList.svelte";
  import PriceRangeSlider from "~/components/filters/PriceRangeSlider/PriceRangeSlider.svelte";

  interface Props {
    filter: Filter;
    value?: string[] | [number, number];
    onChange?: (value: string[] | [number, number]) => void;
  }

  let { filter, value, onChange }: Props = $props();
</script>

{#if filter.type === "checkbox"}
  <FilterCheckboxList
    options={filter.options}
    selectedValues={(value as string[]) ?? []}
    {onChange}
  />
{:else}
  <PriceRangeSlider
    min={filter.min}
    max={filter.max}
    value={(value as [number, number]) ?? [filter.min, filter.max]}
    {onChange}
  />
{/if}
